export class FileHandler {
    id: string;
    contentType: string;
    originalFilename: string;
}
